module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAAAtCAMAAAAX+PImAAAAP1BMVEUAAAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAD/AAA9z5kBAAAAFHRSTlMABa3x6sucdkMdDuLXvIljUzQoFdaz5QsAAACHSURBVDjL7dHJDcQgEERRGzCbd7vyj3VkjVosTRMB7/wPJdVUiSpOfQqqHzgArhd4fLwcBIOPCVIwL/hbZqGwILYdnEjOVnBrJPrmwbsit75s5Y7SXq89UDvK4AJ35cGjweknO3RDyxazQ9tUOlTi6FCZp0NFJtChXLrZQsBvRmkioxjFKMgPEj025xrGm58AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/biaoge-red.png
// module id = 510
// module chunks = 0